import { useUser } from './useUser'

/**
 * Whether the current user has resolved to zero knowledge access.
 *
 * Reads the authoritative `has_access_scopes` flag from the user-info endpoint
 * rather than inferring access from UI state. While the user is still loading
 * (or the request failed) this returns `false`, so the no-access prompt never
 * flashes before access is known.
 */
export function useHasNoAccessScopes(): { hasNoAccessScopes: boolean; isLoading: boolean } {
  const { data: user, isLoading } = useUser()
  const hasNoAccessScopes = !!user && !user.has_access_scopes
  return { hasNoAccessScopes, isLoading }
}
